import React, { PureComponent, createRef, Fragment } from 'react';
import moment from 'moment';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import { stringify } from 'query-string';
import { injectIntl } from 'react-intl';
import { array, func, string, object } from 'prop-types';
import { req } from '../../../services/ApiService.js';
import { statisticsConstants } from '../../../constants/statistics';
import {
  startSetStatistics,
  startSetDictionary,
  startSetWebmasterPresets,
  startCreateWebmasterPreset,
  startUpdateWebmasterPreset,
  startRemoveWebmasterPreset,
  setStatisticsFilters,
  setStatistics,
  startSetStatisticsTabs,
} from '../../../actions/statistics';
import { startSetSlaves, startDeleteSlave, startSetSlaveDictionary, startSetSlaveDictionaryMulti } from '../../../actions/slaves';
import {
  filterParams,
  getUtlParams,
  correctFiltersIfInvalid,
  getSlaveId,
  isMaster,
} from '../statisticsHelpers';
import { getUnique, getStringOrSingleArrayValue, _toFixed } from '../../../utils/utils';
import { iFMessage } from '../../../hoc/IntlComponents';
import { difference, includes, uniq } from 'lodash';
import { StatisticsView } from '../index';

const dictFields = {
  devices: 'brand_id',
  browsers: 'browser_id',
  os: 'os_id',
  landings: 'landing_id',
  transits: 'transit_id',
  offers: 'offer_id',
  leads: 'offer_pixel',
  flows: 'stream_id',
  sources: 'site_id',
};

const filteredTypes = [
  'flows',
  'offers',
  'pixels',
  'devices',
  'browsers',
  'os',
  'landings',
  'transits',
  'sources',
];

const templateCategories = {
  // 2: '6,36,37',
  // 3: '47',
  // 5: '103',
};

const templateParams = {
  1: { categories: [] },
  2: { categories: '6,36,37' },
  // 3: { categories: '47' },
  // 4: { offers: [28176] },
  // 5: { categories: '103' },
  6: { offers: [31449] },
  7: { categories: '47,103,105' },
};
/**
 * Update browser history
 * @param {string} type
 * @param {Object} params
 */
const updateLocation = (type, params, isMembers) => {
  // !isMembers &&
  history.replaceState({}, null, window.location.pathname + '?' + stringify({ type, ...params }));
};

/**
 * Statistics Component
 *
 * @class Statistics
 * @extends {Component}
 */
class Statistics extends PureComponent {
  static propTypes = {
    tabs: array.isRequired,
    type: string,
    stats: array,
    total: object,
    config: array,
    startSetDictionary: func.isRequired,
    startSetStatistics: func.isRequired,
    offers: array,
    flows: array,
    dict: object.isRequired,
  };

  static defaultProps = {
    tabs: [],
    total: {},
    config: [],
    offers: [],
    flows: [],
    dict: {},
  };

  constructor(props) {
    super(props);

    const { type, dateFrom, dateTo, currency, template, ...filters } = props.filters;

    this.state = {
      type: type ? (Array.isArray(type) ? type[0] : type) : 'times',
      filters: {
        dateFrom: dateFrom ? moment(dateFrom, 'DD.MM.YYYY') : moment().subtract(6, 'd'),
        dateTo: dateTo ? moment(dateTo, 'DD.MM.YYYY') : moment(),
        currency: this.getCurrency(),
        template: (template && template.length && template[0]) || 7,
        categories:
          template && template.length && templateParams[template[0]].categories
            ? templateParams[template[0]].categories
            : null,
        offers:
          template && template.length && template[0] === 4
            ? '28176'
            : template && template.length && template[0] === 6
            ? '31449'
            : null,
        ...filters,
      },
      stats: [],
      total: {},
      tab: {},
      loading: true,
      limit: 100,
      page: 0,
      pageCount: 1,
      isMounted: false,
      isPagination: true,
      isChart: true,
      isSharing: false,
      requestParams: null,
      shouldShowCurrenciesTour: false,
      shouldShowStatisticsViewTour: false,
      hasTableEditingModalOpen: false,
      hasActionModalOpen: false,
      hasExportModalOpen: false,
    };

    this.cardHeaderRef = createRef();
  }

  getCurrency = () => {
    const { currency } = this.props.filters;
    const {
      parsedQuery: { currency: urlCurrency },
    } = getUtlParams();
    let curr;
    if (currency && typeof currency === 'array') {
      curr = currency[0];
    } else if (currency && typeof currency === 'number') {
      curr = currency;
    } else if (urlCurrency) {
      curr = +urlCurrency;
    } else {
      curr = 0;
    }
    return curr;
  };

  componentDidMount() {
    const { type, filters } = this.state;
    const {
      isMembers,
      startSetWebmasterPresets,
      startSetSlaves,
      startSetStatisticsTabs,
      setStatisticsFilters,
    } = this.props;

    const defaultFilters = {
      dateFrom: moment().subtract(6, 'd'),
      dateTo: moment(),
      currency: this.getCurrency(),
      template: 7,
      categories: null,
      offers: null,
    };

    setStatisticsFilters(defaultFilters);

    this.setState(
      {
        filters: {
          ...defaultFilters,
          ...this.state.filters,
        },
      },
      () => {
        startSetStatisticsTabs(filters.template);

        const params = [type, this.prepareFilters(this.state.filters)];

        if (isMembers) {
          startSetSlaves().then(slaves => {
            this.getStats(...params, slaves);
            startSetWebmasterPresets();
          });
        } else {
          this.getStats(...params).then((data) => {
            this.autoSwitchCurrency(data);
            // Show currencies tour first
            if (this.checkCurrenciesTourShow(data))
              this.setState({ shouldShowCurrenciesTour: true });
            // If not showing, show view switch tour
            if (!this.checkCurrenciesTourShow(data) && this.checkViewSwitchTourShow())
              this.setState({ shouldShowStatisticsViewTour: true });
            startSetWebmasterPresets();
          });
        }
        this.changeType(type);
      },
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { type } = this.state;
    const { tabs, currentTab } = nextProps;

    let tab = tabs.find(({ id }) => id === type);

    // if (tab && tab.id !== this.state.tab.id) {
    if (tab) {
      this.setState(() => ({ tab }));
      return;
    }

    if (tab === undefined) {
      if (type.search(/subs/) > -1) {
        tab = tabs.find(({ id }) => id === 'subs') || {};
        return;
      }

      tab = tabs.filter(({ tabs = [] }) => tabs.find(({ id }) => id === type));

      if (tab && Array.isArray(tab)) {
        this.setState(() => ({ tab: { ...tab[0] } }));
      }
    }

    if (currentTab && currentTab !== this.props.currentTab) {
      this.changeType(currentTab);
    }
  }

  componentWillUnmount() {
    req.cancel(statisticsConstants.SET_STATS_REQUEST);
  }

  /**
   * Set statistic's page
   * @param {number} [number=1]
   */
  setPage = (number = 1) => {
    const { pageCount } = this.state;
    let page = number - 1;

    if (!isNaN(page) && page >= 0) {
      page = page > pageCount - 1 ? pageCount - 1 : page;
      this.setState(() => ({ page }));
    }
  };

  /**
   * Get page from URL and set it
   */
  getPage = () => {
    const { page = 1 } = parse(location.search);
    this.setPage(page);
  };

  /**
   * Request for additional dictionary
   * @param {string} type
   */
  getDictionary = (type) => {
    const {
      stats = [],
      filters: { currency = 0 },
    } = this.state;

    const {
      filters: { dateFrom, dateTo },
    } = this.props;

    if (stats.length === 0) {
      return;
    }

    const { config } = this.props;
    const field = this.getDictionaryField(type);
    let ids = [];

    const payloadConfig = {
      offers: { dateFrom, dateTo },
    };

    if (type !== 'pixels' && type !== 'leads') {
      const cfg = config.find(({ type }) => type === field);
      const payload = payloadConfig[type];

      if (cfg && cfg.id) {
        ids = uniq(stats.map((stat) => stat[cfg.id][currency]));
        this.requestDictionary(type, ids, payload);
      }

      return;
    }

    if (type === 'pixels') {
      const subDataConfig = config.find(({ type }) => type === 'sub_data');
      const pixelsConfig = config.find(({ type }) => type === 'pixel_id');
      const offersConfig = config.find(({ type }) => type === 'offer_id');
      let offersId, pixelsId, subData;

      if (subDataConfig && pixelsConfig && offersConfig) {
        offersId = getUnique(
          stats.map((stat) => (stat[offersConfig.id] ? stat[offersConfig.id][currency] : null)),
        );

        subData = stats.map((stat) => stat[subDataConfig.id]).filter(Boolean);
        pixelsId = getUnique(
          subData.reduce((pixels, stats) => {
            const ids = stats.map((stat) => stat[pixelsConfig.id][currency]);
            return [...pixels, ...ids];
          }, []),
        );

        this.requestDictionary('offers', offersId, { dateFrom, dateTo });
        this.requestDictionary('pixels', pixelsId);
      }

      return;
    }

    if (type === 'leads') {
      const cfg = config.find(({ type }) => type === field);

      if (cfg) {
        ids = stats.map((stat) => stat[cfg.id][currency]);
        const offersId = getUnique(ids.map((id) => id && id[0]));
        const pixelsId = getUnique(ids.map((id) => id && id[1]));
        offersId && this.requestDictionary('offers', offersId, { dateFrom, dateTo });
        pixelsId && this.requestDictionary('pixels', pixelsId);
      }
      return;
    }
  };

  /**
   * Return parameter's name for dictionary request
   * @param {string} type Statistic's type
   * @return {string} Parameter name
   */
  getDictionaryField = (type) => {
    return dictFields[type];
  };

  filterIds = (type, ids) => {
    if (includes(filteredTypes, type)) {
      let oldIds = [];
      if (this.props[type]) {
        oldIds = oldIds.concat(this.props[type].map(({ id }) => id));
      }
      if (this.props.dict[type]) {
        oldIds = oldIds.concat(this.props.dict[type].map(({ id }) => id));
      }
      const uniqIds = uniq(oldIds);
      return difference(
        ids.filter((id) => id !== null).map((id) => (id === undefined ? 0 : id)),
        uniqIds,
      );
    }
    return [];
  };

  /**
   * Send request for additional dictionaries
   *
   * @param {string} type Dictionary type
   * @param {Array} ids Requested ids
   */
  requestDictionary = (type, ids = [], payload = {}) => {
    const { startSetDictionary, startSetSlaveDictionary, startSetSlaveDictionaryMulti, isMembers } = this.props;
    const filteredIds = this.filterIds(type, ids);
    const master = isMaster();
    let req;
    let reqParams;
    if (!master) {
      req = startSetDictionary;
      reqParams = [type, { ids: filteredIds.join(','), ...payload }];
    } else if (isMembers) {
      const { buyers } = this.state.filters;
      const selectedBuyers = buyers ? String(buyers).split(',').filter(String) : [];
      const idsConnection = selectedBuyers.length > 0
        ? selectedBuyers.join(',')
        : this.prepareSlavesIds(this.props.slaves);
      req = startSetSlaveDictionaryMulti;
      reqParams = [type, { ids: filteredIds.join(','), ids_connection: idsConnection, ...payload }];
    } else {
      req = startSetSlaveDictionary;
      reqParams = [type, { ids: filteredIds.join(','), id: getSlaveId(), ...payload }];
    }
    filteredIds.length > 0 && req(...reqParams);
  };

  /**
   * Send request to get statistics
   *
   * @param {string} type Statistics type
   * @param {Object} filters Filters
   * @return {Promise} Promise object represents request
   */

  prepareSlavesIds = (slaves) => slaves.map(({ id }) => id).join(',');

  getStatsParams = (type, params, slavesOverride) => {
    const { slaves, isMember, isMembers } = this.props;
    const slavesList = slavesOverride || slaves;
    if (!isMember && !isMembers) {
      return { type, params };
    }
    if (isMember) {
      return { type, params: { ...params, ids: getSlaveId() }, isMember };
    }
    if (isMembers) {
      const { dateFrom, dateTo, timeZone, template, categories, offers, flows, statuses, subId1, subId2, subId3, subId4, subId5, buyers } = params;
      const selectedBuyers = buyers ? String(buyers).split(',').filter(String) : [];
      const ids = selectedBuyers.length > 0 ? selectedBuyers : this.prepareSlavesIds(slavesList).split(',').filter(String);

      return {
        type,
        params: {
          dateFrom,
          dateTo,
          timeZone,
          template,
          categories,
          offers,
          flows,
          statuses,
          subId1,
          subId2,
          subId3,
          subId4,
          subId5,
          ids: ids.join(','),
        },
        isMembers,
      };
    }
  };

  getStats = (type, filters, slavesOverride) => {
    const { startSetStatistics, isMembers, intl } = this.props;
    this.setState(() => ({
      loading: true,
      isMounted: true,
    }));

    const filteredFilters = filterParams(type, correctFiltersIfInvalid(filters));

    const params = this.getStatsParams(type, filteredFilters, slavesOverride);

    updateLocation(type, filteredFilters, isMembers);

    this.setState(() => ({
      requestParams: params,
    }));

    return startSetStatistics(params)
      .then(({ data: { items: stats = [], total, 'exceed-limit': exceedLimit = 0 } = {} }) => {
        if (exceedLimit) {
          this.props.showAlert({
            alertType: 'warning',
            message: iFMessage({ intl, id: 'statistics.error.too-much-data' }),
            closeInSeconds: 5,
            dismissable: true,
          });
        }
        this.setState(
          () => ({
            stats,
            total,
          }),
          () => {
            switch (type) {
              case 'devices':
              case 'browsers':
              case 'os':
              case 'landings':
              case 'transits':
              case 'offers':
              case 'pixels':
              case 'flows':
              case 'sources':
                this.getDictionary(type);
                break;

              case 'leads':
                this.getDictionary('flows');
                this.getDictionary('leads');
                break;
            }
            this.getPage();
          },
        );
        return total;
      })
      .catch((err) => {
        // this.props.showAlert({
        //   alertType: 'danger',
        //   message:
        //     err.response?.data?.error?.message?.message || iFMessage({ intl, id: 'main.error' }),
        //   closeInSeconds: 5,
        //   dismissable: true,
        // });
      })
      .finally(() => this.setState({ loading: false }));
  };

  /**
   * Check if currencies tour should be shown
   */
  checkCurrenciesTourShow = (data) => {
    if (localStorage.getItem('offer_tour_complete') || !this.props.currencies) {
      return false;
    }
    if (data && data['127']) {
      const totalConversions = data['127'];
      if (totalConversions && totalConversions.length > 2) {
        const usdConversions = totalConversions[1];
        const eurConversions = totalConversions[2];
        if (usdConversions || eurConversions) {
          return true;
        }
      }
    }
    return false;
  };

  /**
   * Check if view switch tour shoul be shown
   */
  checkViewSwitchTourShow = () =>
    localStorage.getItem('stats_view_switch_tour_complete') ? false : true;

  /**
   * Converting data for requests
   * @param {Object} data Raw data
   * @return {Object} Prepared data
   */
  prepareFilters = (data = {}) =>
    Object.keys(data).reduce((filters, filter) => {
      let offers = templateParams[data.template]?.offers ?? [];
      if (data['offers'] && data['offers']?.length <= 0 && offers.length > 0) {
        data['offers'] = offers.join(',');
      }

      // remove categories for template 1
      // if (filter === 'categories') {
      //   return templateCategories[data.template]
      //     ? { ...filters, categories: templateCategories[data.template] }
      //     : { ...filters, categories: null };
      // }

      if (Array.isArray(data[filter]) && data[filter].length > 0) {
        return { ...filters, [filter]: data[filter].join(',') };
      }

      if (filter === 'dateFrom' || filter === 'dateTo') {
        return moment.isMoment(data[filter])
          ? { ...filters, [filter]: data[filter].format('DD.MM.YYYY') }
          : { ...filters, [filter]: data[filter] };
      }

      // remove empty filters
      if (data[filter] === null || data[filter] === undefined) return filters;

      return { ...filters, [filter]: data[filter] };
    }, {});

  /**
   * Set new filter and update statistics
   * @param {Object} filters Statistic's filters
   */
  handleFilterUpdate = (filters) => {
    const currency = this.getCurrency();
    const { isMembers } = this.props;
    this.props.setStatisticsFilters(
      this.prepareFilters(data ? { ...filters, currency, ...data } : { ...filters, currency }),
    );
    updateLocation(this.state.type, this.prepareFilters({ ...filters, currency }), isMembers);
    const value = this.state.filters.template;
    const data = templateParams[value];
    this.setState(
      () => ({ filters, page: 0 }),
      () => {
        const { type, filters } = this.state;
        this.getStats(
          type,
          this.prepareFilters(
            data
              ? { ...filters, currency, ...data, categories: filters.categories }
              : { ...filters, currency },
          ),
        );
      },
    );
  };

  handleTemplateChange = (template) => {
    const currency = this.getCurrency();
    const { isMembers } = this.props;
    const templateData = templateParams[template] || {};
    const nextFilters = {
      ...this.state.filters,
      template,
      categories: templateData.categories != null ? templateData.categories : null,
      offers: templateData.offers != null ? templateData.offers : null,
    };

    this.props.startSetStatisticsTabs(template);
    this.props.setStatisticsFilters(this.prepareFilters({ ...nextFilters, currency }));
    updateLocation(this.state.type, this.prepareFilters({ ...nextFilters, currency }), isMembers);

    this.setState(
      () => ({ filters: nextFilters, page: 0 }),
      () => {
        const { type, filters } = this.state;
        this.getStats(type, this.prepareFilters({ ...filters, currency, ...templateData }));
      },
    );
  };

  /**
   * Switch to currency with most conversions if user has no RUB, but does have USD/EUR conversions
   * @param {Array} data Data returned from getStats method
   */
  autoSwitchCurrency = (data) => {
    const { fc, template } = this.state.filters;
    // Id of property with conversions data
    const statId = template === 1 ? 127 : template === 2 ? 131 : null;

    if (!fc && data && statId && data[statId]) {
      let [rubConversions, usdConversions, eurConversions] = data[statId];
      // Conversions are strings in gambling stats
      if (statId === 131) {
        rubConversions = parseInt(rubConversions);
        usdConversions = parseInt(usdConversions);
        eurConversions = parseInt(eurConversions);
      }

      if (!rubConversions && (usdConversions || eurConversions)) {
        usdConversions > eurConversions
          ? this.changeCurrency('1', true)
          : this.changeCurrency('2', true);
      }
    }
  };

  /**
   * Set statistic's  currency
   * @param {string} currency Statistic's currency
   * @param {boolean} auto Is change automatic
   */
  changeCurrency = (currency, auto = false) => {
    const { isMembers } = this.props;
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          currency,
          // fixed currency, prevents auto switching on page refresh
          fc: !auto ? true : null,
        },
        requestParams: {
          ...prevState.requestParams,
          params: {
            ...prevState.requestParams.params,
            currency,
          },
        },
      }),
      () => {
        this.props.setStatisticsFilters(this.prepareFilters(this.state.filters));
        updateLocation(this.state.type, this.prepareFilters(this.state.filters), isMembers);
      },
    );
  };

  /**
   * Change statistic's type and reset state
   * @param {string} type Statistic's type
   */
  changeType = (type) => {
    const value = this.state.filters.template;
    const data = templateParams[value];

    this.setState(
      ({ filters }) => ({
        type,
        page: 0,
        stats: [],
        total: {},
        filters: data ? { ...filters, type: [type], ...data } : { ...filters, type: [type] },
      }),
      () => {
        const { type, filters } = this.state;
        const preparedFilters = this.prepareFilters(filters);
        this.props.setStatisticsFilters(preparedFilters);
        this.getStats(type, preparedFilters);
      },
    );
  };

  /**
   * Change tab
   * @param {Object} e Event from click
   * @param {string} type Statistic's type
   */
  handleTabChange = (e, type) => {
    this.changeType(type);
    e.preventDefault();
  };

  /**
   * Change section
   * @param {string} type Statistic's type
   */
  handleSectionChange = (type) => {
    this.setState(
      () => ({ type, page: 0 }),
      () => {
        const { type, filters } = this.state;
        const currency = this.getCurrency();
        this.getStats(type, this.prepareFilters({ ...filters, ...currency }));
      },
    );
  };

  /**
   * Change page
   * @param {number} page New page
   */
  handlePageChange = (page) => {
    this.setState(() => ({ page }));
  };

  /**
   * Request statistics with same filters
   * @param {number} page New page
   */
  handleRefresh = () => {
    this.setState(
      () => ({ page: 0 }),
      () => {
        const { type, filters } = this.state;
        this.getStats(type, this.prepareFilters(filters));
      },
    );
  };

  setPagesCount = (pageCount = 1) => {
    this.setState({ pageCount });
  };

  handleDeleteSlave = (id) => {
    const { startDeleteSlave, showAlert, intl } = this.props;
    startDeleteSlave(id);
    this.setState(({ stats }) => ({ stats: stats.filter((stat) => stat[1][0] !== id) }));
    showAlert({
      alertType: 'success',
      message: iFMessage({ intl, id: 'slaves.delete-member.success' }),
      closeInSeconds: 3,
    });
  };

  handleSettingsUpdate = (settings) => {
    this.setState(
      () => ({
        ...settings,
      }),
      () => {
        this.handlePageChange(0);
      },
    );
  };

  setSharingState = (bool, callback = () => {}) =>
    this.setState(() => ({ isSharing: bool }), callback());

  handleCurrenciesTourFinishClick = () => {
    localStorage.setItem('offer_tour_complete', true);
    this.setState({ shouldShowCurrenciesTour: false }, () => {
      if (this.checkViewSwitchTourShow()) this.setState({ shouldShowStatisticsViewTour: true });
    });
  };

  handleStatisticsViewTourFinishClick = () => {
    localStorage.setItem('stats_view_switch_tour_complete', true);
    this.setState({ shouldShowStatisticsViewTour: false });
  };

  updateTableSettings = (settings) => {
    this.props.setStatistics({ tabs: settings });
  };

  handleHasEditingModalToggle = () => {
    this.setState((prevState) => ({
      hasTableEditingModalOpen: !prevState.hasTableEditingModalOpen,
    }));
  };

  handleHasActionModalToggle = () => {
    this.setState((prevState) => ({
      hasActionModalOpen: !prevState.hasActionModalOpen,
    }));
  };

  handleHasExportModalToggle = () => {
    this.setState((prevState) => ({
      hasExportModalOpen: !prevState.hasExportModalOpen,
    }));
  };

  render() {
    const currency = this.getCurrency();
    const currencies = this.props.currencies.filter((currency) => {
      if (this.state.filters.template === 6) {
        return currency === 'RUB';
      }
      return true;
    });
    const data = { ...this.props, ...this.state, currencies, currency };

    return (
      <StatisticsView
        data={data}
        cardHeaderRef={this.cardHeaderRef}
        handleTabChange={this.handleTabChange}
        handleRefresh={this.handleRefresh}
        handleSectionChange={this.handleSectionChange}
        changeCurrency={this.changeCurrency}
        setPagesCount={this.setPagesCount}
        handleDeleteSlave={this.handleDeleteSlave}
        handlePageChange={this.handlePageChange}
        handleFilterUpdate={this.handleFilterUpdate}
        onSettingsUpdate={this.handleSettingsUpdate}
        updateTableSettings={this.updateTableSettings}
        setSharingState={this.setSharingState}
        onCurrenciesTourFinishClick={this.handleCurrenciesTourFinishClick}
        onStatisticsViewTourFinishClick={this.handleStatisticsViewTourFinishClick}
        handleHasEditingModalToggle={this.handleHasEditingModalToggle}
        handleHasActionModalToggle={this.handleHasActionModalToggle}
        handleHasExportModalToggle={this.handleHasExportModalToggle}
      />
    );
  }
}

const mapStateToProps = ({ statistics, app, webmaster, streams, slaves }) => {
  const {
    parsedQuery: { timeZone: tz },
  } = getUtlParams();
  const timeZone = tz
    ? tz
    : statistics.filters.timeZone
    ? getStringOrSingleArrayValue(statistics.filters.timeZone)
    : webmaster.profile.timezone;
  const master = isMaster();
  return {
    config: statistics.config,
    tabs: statistics.tabs,
    currentTab: statistics.currentTab,
    filters: { ...statistics.filters, timeZone },
    currencies: app.globalSettings.currencies,
    dict: !master ? statistics.dict : slaves.dict,
    offers: !master ? webmaster.offers : slaves.offers,
    flows: !master ? streams.streams : slaves.streams.streams,
    sites: !master ? webmaster.sites : slaves.slaveSites,
    slaves: slaves.ids,
    timeZones: app.globalSettings.timezones,
    countries: app.globalSettings.countries,
    theme: webmaster.profile.theme,
  };
};

const mapDispatchToProps = (dispatch) => ({
  startSetStatistics: (params) => dispatch(startSetStatistics(params)),
  startSetDictionary: (type, params) => dispatch(startSetDictionary(type, params)),
  startSetWebmasterPresets: () => dispatch(startSetWebmasterPresets()),
  startCreateWebmasterPreset: (data) => dispatch(startCreateWebmasterPreset(data)),
  startUpdateWebmasterPreset: (id, data) => dispatch(startUpdateWebmasterPreset(id, data)),
  startRemoveWebmasterPreset: (id) => dispatch(startRemoveWebmasterPreset(id)),
  setStatisticsFilters: (filters) => dispatch(setStatisticsFilters(filters)),
  startSetSlaves: () => dispatch(startSetSlaves()),
  startDeleteSlave: (id) => dispatch(startDeleteSlave(id)),

  startSetSlaveDictionary: (type, params) => dispatch(startSetSlaveDictionary(type, params)),
  startSetSlaveDictionaryMulti: (type, params) => dispatch(startSetSlaveDictionaryMulti(type, params)),

  setStatistics: (data) => dispatch(setStatistics(data)),
  startSetStatisticsTabs: (template) => dispatch(startSetStatisticsTabs(template)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(Statistics)));
